import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcLicensing = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5v-2H5V5h12v3.6a5.022 5.022 0 0 1 2 0V5a2 2 0 0 0-2-2H5Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M15.5 15.95A3.49 3.49 0 0 0 18 17a3.49 3.49 0 0 0 2.5-1.05V14h-5v1.95Zm0 1.881V23l2.5-1.5 2.5 1.5v-5.169a4.977 4.977 0 0 1-2.5.669c-.91 0-1.765-.244-2.5-.669Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M21.5 13.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M23 13.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0ZM18 17a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z",
  fill: "var(--mds-nav-border-medium)",
  fillRule: "evenodd"
})), "IcLicensing");

export { IcLicensing };
//# sourceMappingURL=ic-licensing.js.map
